var _circle, _path, _circle2, _circle3, _path2, _circle4, _path3, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecursosLogoBw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#AAAAA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9155 21.6641C39.4999 19.1931 36.962 15.5291 35.4122 13.574C33.4409 11.0871 26.5412 12.0818 26.5412 16.0608C26.5412 18.0503 26.5412 22.5267 26.5412 27.0032",
    stroke: "white",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.755,
    cy: 27.0032,
    r: 8.03529,
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.7546,
    cy: 27.0032,
    r: 5.24973,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64893 21.2534C9.14317 18.7824 10.6128 15.5291 12.2487 13.574C14.3296 11.0871 21.6126 12.0818 21.6126 16.0608C21.6126 18.0503 21.6126 22.5267 21.6126 27.0032",
    stroke: "white",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3986,
    cy: 27.0032,
    r: 8.03529,
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6123 16.3251H26.5406M21.6123 21.2534H26.5406",
    stroke: "white",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3987,
    cy: 27.0032,
    r: 5.24973,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecursosLogoBw);
export default __webpack_public_path__ + "static/media/recursos-logo-bw.459894670836019950ae3a06b295f778.svg";
export { ForwardRef as ReactComponent };